
import { Check, X } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { CardActionProps } from './types';

export const CardActions = ({ 
  isPreferred, 
  isExcluded, 
  onTogglePreferred, 
  onToggleExcluded,
  providerName
}: CardActionProps) => {
  return (
    <div className="absolute right-2 top-4 flex gap-2">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              onClick={() => onTogglePreferred(providerName)}
              className={`p-1.5 rounded-full transition-colors ${
                isPreferred
                  ? 'bg-primary/20 text-primary'
                  : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
              }`}
              aria-label={isPreferred ? "Remove from preferred" : "Add to preferred"}
            >
              <Check className="h-4 w-4" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="left">
            <p>{isPreferred ? "Remove from preferred" : "Add to preferred"}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              onClick={() => onToggleExcluded(providerName)}
              className={`p-1.5 rounded-full transition-colors ${
                isExcluded
                  ? 'bg-red-100 text-red-600'
                  : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
              }`}
              aria-label={isExcluded ? "Remove from excluded" : "Add to excluded"}
            >
              <X className="h-4 w-4" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="left">
            <p>{isExcluded ? "Remove from excluded" : "Add to excluded"}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
